export const USER_SESSION_REQUEST = 'USER_SESSION_REQUEST';
export const USER_SESSION_SUCCESS = 'USER_SESSION_SUCCESS';

export const USER_SIGNIN_REQUEST = 'USER_SIGNIN_REQUEST';
export const USER_SIGNIN_SUCCESS = 'USER_SIGNIN_SUCCESS';
export const USER_SIGNIN_FAIL = 'USER_SIGNIN_FAIL';
export const USER_SIGNOUT = 'USER_SIGNOUT';
export const USER_GET_OTP_REQUEST = 'USER_GET_OTP_REQUEST';
export const USER_GET_OTP_REQUEST_SUCCESS = 'USER_GET_OTP_REQUEST_SUCCESS';
export const USER_GET_OTP_REQUEST_FAIL = 'USER_GET_OTP_REQUEST_FAIL';
export const USER_SIGNUP_SIGNIN_ERROR = 'USER_SIGNUP_SIGNIN_ERROR';
export const OPEN_CLOSE_SIDE_BAR_MENU = 'OPEN_CLOSE_SIDE_BAR_MENUR';
export const OPEN_CLOSE_PAYMENT_TRANSACTION_MODAL = "OPEN_CLOSE_PAYMENT_TRANSACTION_MODAL";
export const ALL_TRANSACTION_DETAIL_LIST_SUCCESS = "ALL_TRANSACTION_DETAIL_LIST_SUCCESS";
export const ALL_TRANSACTION_DETAIL_LIST_REQUEST = "ALL_TRANSACTION_DETAIL_LIST_REQUEST";

export const LPG_BOOKING_TRANSACTION_HISTORY_REQUEST = 'LPG_BOOKING_TRANSACTION_HISTORY_REQUEST';
export const LPG_BOOKING_TRANSACTION_HISTORY_SUCCESS = 'LPG_BOOKING_TRANSACTION_HISTORY_SUCCESS';
export const LIC_PAYMENT_TRANSACTION_DETAILS_REQUEST = "LIC_PAYMENT_TRANSACTION_DETAILS_REQUEST";
export const LIC_PAYMENT_TRANSACTION_DETAILS_SUCCESS = 'LIC_PAYMENT_TRANSACTION_DETAILS_SUCCESS'
